<template>
	<div class="jobs">
		<b-container fluid class="mt-top text-left pwi90">
			<b-row class="mb-3 top-text prl-inside pr-0 mx-0">{{$t('title')}}</b-row>
			<b-carousel fluid
				id="carousel"
				controls
				v-model="slide"
				:interval="interval"
				background="#fffff"
				@sliding-start="onSlideStart"
				@sliding-end="onSlideEnd"
			>
				<b-carousel-slide class="pvh-auto video">
					<div class="carosel-text-frame-video">
						<video
							title="Gera Montagen"
							style="background-color: rgb(0, 0, 0);width: 70%; height: auto;"
							webkit-playsinline="true"
							playsinline="true"
							:src="$store.state.domain +'video/GERA_Video.mp4'"
							autoplay
							muted
							controls="controls"
							@playing="playing"
							@ended="ended"
							@paused="paused">
						</video>
					</div>
				</b-carousel-slide>

				<b-carousel-slide :key="key" v-for="(slide, key) in slides" :img-src="slide.picture" class="pvh-auto">
					<div class="carosel-text-frame" style="height:auto;">
						<div class="carosel-text text-left mr-4">{{slide.text}}</div>
						<div class="carosel-text-desription text-left">
							<h3>{{$t('yourProfile')}}:</h3>
							<ul v-if="slide.profiles" class="fw700" style="margin-left:-25px;">
								<li v-for="(profile, pkey) in slide.profiles" :key="pkey" class="mb-2">{{profile.name}}</li>
							</ul>
						</div>
					</div>
				</b-carousel-slide>
			</b-carousel>

			<b-row class="p-0 mb-5 mx-auto" v-if="$i18n.locale=='de'">
				<b-col class="mx-auto" cols="12" lg="9">
					<h3>{{$t('title1')}}</h3>
					<p>{{$t('text1_1')}}</p>
					<p>{{$t('text1_2')}}</p>
					<h3>{{$t('title2')}}</h3>
					<p>{{$t('text2')}}</p>
					<h3>{{$t('title3')}}</h3>
					<p>{{$t('text3')}}</p>
					<h3>{{$t('title4')}}</h3>
					<p>{{$t('text4')}}</p>

          <ul class="boxes">
            <li v-for="box of boxes" :key="box.hl">
              <h2>
                <img :src="`/img/jobs/${box.icon}`">
                <span v-html="box.hl"></span>
              </h2>
              <p v-text="box.content"></p>
            </li>
          </ul>

					<h3 class="pt-5 mb-4 w-100 text-center" style="font-style:italic;font-weight:600;">{{$t('title5')}}</h3>
				</b-col>
			</b-row>
			<b-row class="p-0 mb-5 mx-auto">
				<div class="gera-btn text-center mx-auto" @click="$router.push('/jobs/apply')">{{$t('applyNow')}}</div>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import mainJobPic from '@/assets/img/GERA_Jobs.jpg'
import mainJobPicH from '@/assets/img/GERA_Jobs_hor.jpg'

export default {
	name: 'Jobs',
	data () {
		return {
			windowWidth: 1920,
			slide: 0,
			sliding: null,
			interval: 4000,
			slides: [
				{
					picture: mainJobPic,
					text: this.$t('sliderText'),
					profiles: [
						{ name: this.$t('profileText1') },
						{ name: this.$t('profileText2') },
						{ name: this.$t('profileText3') },
						{ name: this.$t('profileText4') },
					]
				}
			]
		}
	},
	methods: {
		onSlideStart (slide) {
			this.sliding = true
		},
		onSlideEnd (slide) {
			this.sliding = true
		},
		playing () {
// 			console.log('Video start')
			this.interval = 0
		},
		ended () {
//			console.log('End of Video')
			this.interval = 4000
		},
		paused () {
//			console.log('Video paused')
			this.interval = 4000
		}
	},
	created () {
		this.windowWidth =  Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
		if (this.windowWidth<=768) { this.slides[0].picture = mainJobPicH; } else { this.slides.forEach(slide => { slide.picture = mainJobPic; }) }
		window.addEventListener('resize', () => {
		this.windowWidth =  Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
			if (this.windowWidth<=768) { this.slides[0].picture = mainJobPicH; } else { this.slides.forEach(slide => { slide.picture = mainJobPic; }) }
		this.$forceUpdate();
		})
	},
  computed: {
    boxes() {
      const icons = [
        'GERA_A5_Folder_Icons_Zeichenfläche 1-01.png',
        'GERA_A5_Folder_Icons_Zeichenfläche 1-03.png',
        'GERA_A5_Folder_Icons_Zeichenfläche 1-05.png',
        'GERA_A5_Folder_Icons_Zeichenfläche 1 Kopie.png',
        'GERA_A5_Folder_Icons_Zeichenfläche 1 Kopie 3.png',
        'GERA_A5_Folder_Icons_Zeichenfläche 1-02.png',
        'GERA_A5_Folder_Icons_Zeichenfläche 1-04.png',
        'GERA_A5_Folder_Icons_Zeichenfläche 1-06.png',
        'GERA_A5_Folder_Icons_Zeichenfläche 1 Kopie 2.png',
      ]

      return icons.map((icon, i) => ({ icon, hl: this.$t(`boxes_${i}_hl`), content: this.$t(`boxes_${i}_content`) }))
    }
  }
}
</script>
<style lang="scss">
.video {
	height:60vw !important;
}
.jobs .container-fluid {
	max-width: 1400px;
}
.jobs .carousel-control-prev, .jobs .carousel-control-next {
  width: auto !important;
}
.jobs .carousel {
	margin-top: -40px;
    text-shadow: none; /* 1px 1px 2px #333; */
 }
.jobs .carousel-caption {
 	top: 0;
 	left: 0;
 	width: 100%;
 	height: 100%;
 	right: unset !important;
 	bottom: unset !important;
 }
.carosel-big-text-top {
  position:absolute;
  font-weight:100;
  font-family:"Gotham-Thin";
  font-size:100px;
  color:#777;
  text-shadow:none;
  left:50px;
}
.jobs .carosel-text-frame {
	position: absolute;
	width: 70%;
	height: auto;
	bottom: -80px;
	right: 70px;
}
.jobs .carosel-text, .jobs .carosel-text-desription {
	position: absolute;
	width: 35%;
	height: 100%;
	min-height: 235px;
	background-color: rgba(50,50,50,0.8);
	padding: 20px;
	font-weight: 500;
	border-radius: 0 0 20px 0;
	font-size: 15px;
	text-shadow: none;
}
.jobs .carousel-inner {
	height: 600px;
}
.jobs .carosel-text {
	float:left;
	position: relative;
	width:60%;
	font-size: 14px;
	height: 100%;
}
.jobs .carosel-text-desription {
 	float:right;
	position: relative;
}
.jobs .carousel-control-prev {
    left: -50px !important;
}
.jobs .carousel-control-next {
    right: -50px !important;
}
.jobs .carousel-control-prev-icon {
    background-image: url("../assets/img/Arrow_Slider_Left.png") !important;
    background-size: 40px !important;
    width: 45px !important;
    height: 100px !important;
	  }
.jobs .carousel-control-next-icon {
    background-image: url("../assets/img/Arrow_Slider_Right.png") !important;
    background-size: 40px !important;
    width: 45px !important;
    height: 100px !important;
  }
.pvh-auto {
	padding: 8vh 8vw;
}
.pwi90 {
	padding: 0 90px !important;
}
.carosel-text-frame-video {
 	margin-top:50px;
 	width: 140%;
 	max-width: 1200px;
 	margin-right: auto;
}
ul.boxes {
  list-style-type: none;
  margin: 50px 0;
  padding: 0;
  columns: 2;

  li {
    width: 80%;
    padding-bottom: 50px;
    break-inside: avoid-column;

    h2 {
      color: #307bad;
      font-size: 30px !important;

      img {
        float: right;
        height: 40px;
        margin-left: 20px
      }
    }
  }

  @media only screen and (max-width: 1280px) {
    columns: 1;

    li {
      width: 100%;

      h2 img {
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
	.carosel-text-frame-video {
 		max-width: 1100px;
		margin-left: -10% !important;
	}
}
@media only screen and (max-width: 992px) {
	.carosel-text-frame-video {
		/* margin-right: unset; */
		margin-left: -20% !important;
	}
	.carosel-big-text-top {
	  font-size:80px;
	  left:0;
	}
	.pvh-auto {
		padding: 10vh 5vw;
	}
	.jobs .carosel-text-frame {
		right: 0 !important;
	}
	.carosel-text {
		margin-right: 0 !important;
		font-size: 11.5px !important;
	}
	.carosel-text-desription {
		font-size: 11.5px !important;
	}
}
@media only screen and (max-width: 870px) {
	.jobs .carosel-text {
		width:59%;
	}
}

@media only screen and (max-width: 768px) {
	.jobs .carousel-inner {
		height: auto;
	}
	.jobs .carousel {
	    margin-bottom: 50px;
	 }
	.carosel-big-text-top {
	  font-size:50px;
	  top:30px;
	  left:0;
	}
	.pvh-auto {
		padding: 8vh 5vw;
	}
	.carosel-text-frame {
		width: 70%;
		right: 0 !important;
		bottom: 0 !important;
	}
	.carosel-text {
		width:100% !important;
		float:left !important;
		font-size: 1em !important;
		margin-bottom:30px;
	}
	.carosel-text-desription {
		width:100% !important;
		float:left !important;
		font-size: 1em !important;
	}
}
@media only screen and (max-width: 576px) {
	.jobs .carousel {
		margin-top: -60px;
		width: 100%;
	 }
	 .jobs .top-text {
		 font-size: 2.6em !important;
	 }
	.carosel-big-text-top {
	  top:40px;
	  font-size:45px;
	  left:0;
	}
	.pwi90 {
	    padding: 0 5px !important;
	}
	.jobs .carosel-text {
		font-size: 14px !important;
	}
	.jobs .carousel-control-prev {
		display: none;
	}
	.jobs .carousel-control-next {
		display: none;
	}
}
</style>
<i18n>
{
  "de": {
    "title": "Wir suchen dich",
    "sliderText": "Die ganze Welt kann zu deiner Spielwiese werden: Als Montagetischler bei GERA erwarten dich interessante und anspruchsvolle Aufträge, von denen du schon in deinem Spielzimmer geträumt hast – und das, auf aller Welt. Natürlich sind uns unsere Mitarbeiter ebenso wichtig wie unsere Kunden – daher herrscht bei uns ein harmonisches und angenehmes Arbeitsklima. Freu dich gemeinsam mit einem erfahrenen, dynamischen und motivierten Team zu arbeiten und über die Wertschätzung unserer zufriedenen Kunden.",
    "yourProfile": "Dein Profil",
    "profileText1": "Lehrabschluß als Bau- oder Möbeltischler",
    "profileText2": "Leidenschaft für deine Arbeit",
    "profileText3": "Sorgfalt bei Arbeit",
    "profileText4": "Reisebereitschaft",
    "applyNow": "Jetzt bewerben!",
    "title1": "Gemeinsam jeder Herausforderung gewachsen",
    "text1_1": "Als Team sind wir stark und dazu brauchen wir dich. Wir sind immer auf der Suche nach engagierten Montagetischlern und haben genau den richtigen Job für dich: Anspruchsvolle, aber ebenso lohnenswerte Aufträge rund um den Globus zusammen mit legeren Kollegen.",
    "text1_2": "Montagetischler bei GERA haben einen vielseitigen und aufregenden Job – ob Montagen in den teuersten und exklusivsten Hotels wie beispielsweise der Luxushotelkette Hilton, oder auf edlen Yachten, so groß wie Einfamilienhäuser – überall haben wir unsere Finger im Spiel. Darum suchen wir Montagetischler, die ihr potenzial zur Gänze ausschöpfen und ihre Berufung zum Beruf machen wollen.",
    "title2": "Dein Aufgabenbereich:",
    "text2": "Du darfst dich an den spannendsten und luxuriösesten Orten austoben. Dein Können zeigst du bei Montagearbeiten des Interieurs von Luxushotels und auf modernen Luxus- und Megayachten rund um die Welt aber auch in öffentlichen Gebäuden bei großen Empfangshallen und Foyers. Dabei achtest du auf jedes kleine Detail und sorgst dafür, dass alles ins richtige Licht gerückt ist.",
    "title3": "Das bringst du mit:",
    "text3": "Du bist Teamfähig und bist eine ideale Ergänzung für ein dynamisches Team, du arbeitest sorgfältig und genau und kannst knifflige Aufgaben auch alleine lösen. Du bist gerne unterwegs und möchtest aufregende Jobs rund um die Welt erledigen. Die Montagetischlerei ist nicht nur ein Beruf, sondern deine Berufung.",
    "title4": "Das bieten wir dir:",
    "text4": "Vielfältige, herausfordernde und abwechslungsreiche Arbeiten rund um den Globus, ob auf Luxusyachten oder schicken Hotels, wir haben alles im Portfolio. Junge, engagierte und motivierte Arbeitskollegen, die nach höchster Qualität und Perfektion streben und sich so gemeinsam neuen Herausforderungen stellen. Und das alles in einem angenehmen Betriebs-und Arbeitsklima.",
    "title5": "Das klingt genau nach dir? Dann bewirb dich:",
    "boxes_0_hl": "NUR DAS BESTE OUTFIT",
    "boxes_0_content": "Nur wer gute, praktische Arbeitskleidung hat, kann Top-Arbeit leisten. Daher kümmern wir uns darum, dass Ihr Euer Outfit nur mehr in der Zentrale abholen müsst – und stylisch sind die \"Blaumänner\" obendrauf.",
    "boxes_1_hl": "GUTER RAT ZUR RICHTIGEN ZEIT",
    "boxes_1_content": "Bei Fragen in den Bereichen Immobilien, Versicherung und Finanzierung stehen wir Dir aufgrund unserer umfangreichen Erfahrung in diesen Bereichen jederzeit gerne zur Seite. Natürlich haben wir auch sonst immer ein offenes Ohr und unterstützen dich, wo auch immer wir können!",
    "boxes_2_hl": "WIR SICHERN DEINE ZUKUNFT",
    "boxes_2_content": "Ab dem dritten Jahr der Unternehmenszugehörigkeit finanzieren wir eine monatliche Zukunftsvorsorge in der Höhe von € 25,- für dich.",
    "boxes_3_hl": "GEBURTSTAG: MEHR ALS EIN HÄNDEDRUCK",
    "boxes_3_content": "Wir feiern deinen Geburtstag! Und das bedeutet mehr, als nur einen warmen Händedruck. Du bekommst ein kleines Geschenk, das von Herzen kommt.",
    "boxes_4_hl": "DIE RUNDEN GEBURTSTAGE FEIERN WIR BESONDERS",
    "boxes_4_content": "Mit den runden Geburtstagen von jedem von Euch gibt es etwas ganz Besonderes zu feiern und da lassen wir uns nicht lumpen: Je nach Zugehörigkeitsdauer zum Unternehmen gibt es verschiedene Gutscheine, um diese speziellen Geburtstage zusätzlich abzurunden.",
    "boxes_5_hl": "UNSERE KONDITIONEN SIND DEIN VORTEIL",
    "boxes_5_content": "Du möchtest ein Haus bauen oder benötigst einen neuen Parkett, Innentüren... Wir geben Dir gerne die guten Einkaufskonditionen, die wir bei unseren Lieferantenpartnern haben nach Möglichkeit weiter.",
    "boxes_6_hl": "SCHÖNE WEIHNACHTEN",
    "boxes_6_content": "Zu Weihnachten schütten wir eine Weihnachtsprämie aus, die von der Dauer der Zugehörigkeit und der Leistung im vergangenen Jahr abhängt.",
    "boxes_7_hl": "KOSTENLOSER STEUERAUSGLEICH",
    "boxes_7_content": "Als GERA-Mitarbeiter hast du die Möglichkeit, deinen Steuerausgleich auf Kosten von GERA bei unserem Steuerberater machen zu lassen.",
    "boxes_8_hl": "TREUE WIRD BELOHNT: GUTSCHEINE AB 10 JAHREN UNTERNEHMENS<wbr>ZUGEHÖRIGKEIT",
    "boxes_8_content": "Wenn du länger als 10 Jahre zum Gera-Team gehörst, wirst Du gefeiert: Ab zehn Jahren Zugehörigkeit gibt es für dich in fünf Jahresschritten Gutscheine als Treuegeschenk – mit gemeinsamen Essen und einer Urkunde, die feierlich überreicht wird."
  },
  "en": {
    "title": "We are looking for you",
    "sliderText": "The whole world can be your workplace. As an installation carpenter at GERA, interesting, challenging jobs are waiting for you that you have been dreaming about since you played in a playroom – and you can do these jobs all over the world. Our employees are as important to us as our customers which is why we have a harmonious, pleasant work environment. You will be glad to work together with a young, dynamic, motivated team, and you will like the appreciation from our happy customers.",
    "yourProfile": "Your profile",
    "profileText1": "Apprenticeship diploma as a carpenter or cabinet maker",
    "profileText2": "Passionate about your work",
    "profileText3": "Accuracy at work",
    "profileText4": "Willingness to travel",
    "applyNow": "Apply now!"
  }
}
</i18n>
